import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldJoystick: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconOldJoystick"><Path d="M12 3C13.933 3 15.5 4.567 15.5 6.5C15.5 8.17545 14.3224 9.57452 12.75 9.91797V14H16.5V11.75C16.5 11.3358 16.8358 11 17.25 11C17.6642 11 18 11.3358 18 11.75V14H20.25C20.6642 14 21 14.3358 21 14.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V14.75C3 14.3358 3.33579 14 3.75 14H11.25V9.91797C9.67756 9.57452 8.5 8.17545 8.5 6.5C8.5 4.567 10.067 3 12 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOldJoystick;
